"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHfilterTranslateState = void 0;
exports.defaultHfilterTranslateState = {
    forRent: 'For Rent',
    forSale: 'For Sale',
    selected: 'Selected',
    select: 'Select',
    continueNext: 'Continue',
    custom: 'Customize',
    unlimited: 'Unlimited',
    filters: 'Filters',
    sort: 'Sort',
    sortBy: 'Sort By',
    saveSearch: 'Save Search',
    save: 'Save',
    list: 'List',
    map: 'Map',
    keywordPlaceholder: 'Keywords',
    clear: 'Clear',
    reset: 'Clear All',
    selectAll: 'Select All',
    search: 'Search',
    district: 'District',
    selectedDistricts: 'Select Districts',
    price: 'Price',
    priceSelect: 'Select Max. Price',
    buy: 'Buy',
    rent: 'Rent',
    sf: 'SF',
    sizeSf: 'Size (SF)',
    sizeSfSelect: 'Select Min. Size (SF)',
    beds: 'Beds',
    bedsSelect: 'Bedrooms',
    propertyType: 'Property Type',
    propertyTypeSelect: 'Select Property Type(s)',
    amenities: 'Amenities',
    showVrVideo: 'Show Virtual Tour / Video',
    hongKongIsland: 'Hong Kong Island',
    kowloon: 'Kowloon',
    newTerritories: 'New Territories',
    outlyingIslands: 'Outlying Islands',
    keywordEmptyHint: 'Please enter building keyword (eg. Centrestage)',
    keyword: 'Keyword',
    suggestions: 'Suggestions',
    locations: 'Locations',
    buildings: 'Buildings',
    recentSearch: 'Recent Search',
    closeMap: 'Close',
    showMap: 'Show',
    bed0: 'Studio',
    bed1: '1+',
    bed2: '2+',
    bed3: '3+',
    bed4: '4+',
    bed5: '5+',
    type1: 'Apartment',
    type2: 'Duplex',
    type3: 'Triplex',
    type4: 'Penthouse',
    type5: 'House',
    type7: 'Studio',
    type17: 'Village House',
    amenity1: 'Carpark',
    amenity2: 'Maid\'s Room',
    amenity3: 'Outdoor Space',
    vrVideo1: 'Virtual Tour',
    vrVideo2: 'Video',
    sort0: 'Best Match',
    sort1: 'Price (Low to High)',
    sort2: 'Price (High to Low)',
    sort3: 'Price per sq.ft. (Low to High)',
    sort4: 'Price per sq.ft. (High to Low)',
    sort5: 'Size (Large to Small)',
    sort6: 'Size (Small to Large)',
    sort7: 'District Name (A-Z)',
    sort8: 'District Name (Z-A)',
    sort9: 'Building Name (A-Z)',
    sort10: 'Building Name (Z-A)',
    sort11: 'Last Updated',
    below: 'Below',
    above: 'Above',
    over: 'Over',
    any: 'Any',
    back: 'Back',
    applyFilter: 'Apply Filter?',
    applyFilterCaption: 'Filter has changed. Do you want to apply the new filter?',
    applyFilterYes: 'Yes',
    applyFilterNo: 'No',
    clearBoundary: 'Clear Boundary',
    districts: 'Districts',
    estates: 'Estates',
    phases: 'Phases',
    roads: 'Roads',
    histories: 'Recent Search',
};
